import { graphql } from '~/gql';

export const RetainerFieldsFragment = graphql(`
  fragment RetainerFields on Retainer {
    id
    matterExpertId
    status
    title
    workType
    feeBreakdownType
    feeType
    flatFee
    hourlyFee
    hoursRequested
    additionalDetails
    subtotal
    platformFee
    total
    expertAgreedAt
    attorneyAgreedAt
    declinedMessage
    closedMessage
    expertClosedAt
    attorneyClosedAt
    paidAt
    workCompletedAt
    createdAt
    updatedAt
    matterExpert {
      id
      expertId
      status
      expert {
        id
        name
        email
        avatarUrl
      }
    }
  }
`);

export const RetainersForMatterDocument = graphql(`
  query RetainersForMatter($matterId: BigInt!) {
    retainersForMatter(matterId: $matterId) {
      ...RetainerFields
    }
  }
`);
